import React from 'react'
import { Badge } from '../Badge'

interface AvatarProps {
  className?: string
  size?: string
  src?: string
  name?: string
  type?: string
}

const sm = 'h-10 w-10'
const md = 'h-14 w-14'
const lg = 'h-20 w-20'

const getAvatarSize = (size: string | undefined) => {
  switch (size) {
    case 'sm':
      return `${sm}`
    case 'md':
      return `${md}`
    case 'lg':
      return `${lg}`
    default:
      return `${sm}`
  }
}

const getTextSize = (size: string | undefined) => {
  switch (size) {
    case `${sm}`:
      return 'text-base py-2'
    case `${md}`:
      return 'text-xl py-3.5'
    case `${lg}`:
      return 'text-3xl py-5'
    default:
      return 'text-base py-2'
  }
}

function getInitials(name: string) {
  const [firstName, lastName] = name.split(' ')
  return firstName && lastName
    ? `${firstName.charAt(0)}${lastName.charAt(0)}`
    : firstName.charAt(0)
}

export const Avatar = ({
  className = 'info',
  size = 'default',
  src = 'https://picsum.photos/200', // Need to handle broken images
  name = 'Avatar Image',
  type
}: AvatarProps) => {
  const sizeOption = getAvatarSize(size)
  const textSize = getTextSize(`${sizeOption}`)
  const [showInitials, setshowInitials] = React.useState(false)
  const svgWidth = size === 'sm' ? 25 : 35
  const svgHeight = size === 'sm' ? 10 : 20

  const initials = getInitials(`${name}`)
  const handleError = () => {
    setshowInitials(true)
  }
  return (
    <div className='relative inline-block top-0 left-0'>
      <div
        className={`${sizeOption}  rounded-full bg-gray-200 overflow-hidden relative`}
      >
        <img
          className={`${className}`}
          src={src}
          alt={name}
          onError={() => handleError()}
        />
      </div>
      <div className='absolute left-0 bottom-0 z-10'>
        {type && (type === 'Club' || type === 'Elite' || type === 'Beyond') ? (
          <Badge type={type} height={svgHeight} width={svgWidth} />
        ) : (
          ''
        )}
      </div>
      {showInitials ? (
        <span
          className={`absolute bg-gray-200 text-gray-900 left-0 top-0 ${textSize} bold text-center w-full h-full rounded-full`}
        >
          {initials}
        </span>
      ) : (
        ''
      )}
    </div>
  )
}
